import styled from "styled-components";
import StyledButtonWithIcon from "../../styledButtonWithIcon/StyledButtonWithIcon";

export const PDFDownloadButtonContainer = styled.div<{ fullWidth?: boolean }>`
    ${(props) => props.fullWidth && "width: 100%;"}

    a:link {
        text-decoration: none;
    }
`;

export const PDFDownloadInnerButton = styled(StyledButtonWithIcon)<{ fullWidth?: boolean }>`
    ${(props) =>
        props.fullWidth &&
        `
        width: 100%;
        min-width: 0;
    `}

    a:link {
        text-decoration: none;
    }

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        width: 100%;
    }
`;
